import { useState } from "react";
import axios from "axios";
import { getDataFromLocalStorage } from "../util/localStorage";

const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(null);

  const callApi = async (url, method = "GET", data = null, headers = {}) => {
    setLoading(true);
    setError(null);
    setResponse(null);

    try {
      const token = getDataFromLocalStorage("token");
      const finalHeaders = { ...headers };
      if (token && !finalHeaders.Authorization) {
        finalHeaders.Authorization = `Bearer ${token}`;
      }

      const res = await axios({
        url,
        method,
        data,
        headers: finalHeaders,
      });
      setResponse(res.data); // Store the response
      setLoading(false);
      return res.data; // Return response for immediate use
    } catch (err) {
      console.error("API Error:", err);
      const errorMessage =
        err.response?.data?.message || err.message || "An error occurred.";
      setError(errorMessage); // Store error message
      setLoading(false);
      throw new Error(errorMessage); // Re-throw for optional further handling
    }
  };

  return { callApi, loading, error, response };
};

export default useApi;
